export const redirects = {
  gdansk: {
    campaign: "magnet_gdansk_2026",
    url: "https://www.google.com/maps/dir//Whitebull+SteakHouse+Gdansk",
  },
  torun: {
    campaign: "magnet_torun_2026",
    url: "https://www.google.com/maps?daddr=Mostowa+36,+87-100+Torun",
  },
  bydgoszcz: {
    campaign: "magnet_bydgoszcz_2026",
    url: "https://www.google.com/maps/dir//WhiteBull+SteakHouse+Bydgoszcz",
  },
  "menu-gdansk": {
    campaign: "menu_qr",
    url: "https://whitebull.com.pl/menu/gdansk",
  },
  "menu-torun": {
    campaign: "menu_qr",
    url: "https://whitebull.com.pl/menu/torun",
  },
  club: {
    campaign: "club_qr",
    url: "https://whitebull.com.pl/club",
  },
  academy: {
    campaign: "academy_qr",
    url: "https://whitebull.com.pl/academy",
  },
  harley: {
    campaign: "harley_qr",
    url: "https://whitebull.com.pl/harley",
  },
  founders: {
    campaign: "founders_qr",
    url: "https://whitebull.com.pl/founders",
  },
  energy: {
    campaign: "energy_qr",
    url: "https://whitebull.com.pl/energy",
  },
};

export const getRedirectBySlug = (slug) => redirects[slug] ?? null;
